<template>
  <div>
    <a @click="openWarningModal" v-if="isSuperadmin">
      <button class='btn btn-sm btn-success'>{{ $t('backend.customers.import.import') }}</button>
    </a>
    <a :href="route" v-if="!isSuperadmin">
      <button class='btn btn-sm btn-success'>{{ $t('backend.customers.import.import') }}</button>
    </a>
    <div class="hidden" ref="modalText">
      <br>
      <strong>{{$t('backend.importer_mapping.please_check_data')}}:</strong>
      <br>
      <br>
      <table class="center table">
        <tr>
          <th>{{$t('backend.importer_mapping.filename')}}:</th>
          <td>{{originalFilename}}</td>
        </tr>
        <tr>
          <th>{{$t('backend.importer_mapping.mapping')}}:</th>
          <td>{{mappingName}}</td>
        </tr>
        <tr>
          <th>{{$t('backend.importer_mapping.client')}}:</th>
          <td>{{clientName}}</td>
        </tr>
        <tr>
          <th>{{$t('backend.importer_mapping.data_sets')}}:</th>
          <td>{{fileRows}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerMappingsSubmitButton",
  props: ['route', 'clientName', 'originalFilename', 'fileRows', 'mappingName', 'isSuperadmin'],
  methods: {
    openWarningModal() {
      this.$swal({
        icon: 'warning',
        title: this.$t('backend.importer_mapping.are_you_sure'),
        html: this.$refs.modalText.innerHTML,
        showCancelButton: true,
        cancelButtonText: this.$t('backend.importer_mapping.cancel'),
        confirmButtonText: this.$t('backend.importer_mapping.customer_import'),
        width: 500
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = this.$props.route;
        }
      });
    }
  }
}
</script>

<style scoped>
.center {
  margin-left: auto;
  margin-right: auto;
}
th {
  padding-right: 15px;
}
td {
  text-align: left;
}
</style>
